export default "__VITE_ASSET__CGm1xbWg__"